var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCcpEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.643 5.46669L13.6445 3.73205C14.1968 2.77547 15.42 2.44772 16.3766 3L16.7258 3.20164C17.6824 3.75393 18.0102 4.97711 17.4579 5.93369L16.4564 7.66833M12.643 5.46669L7.44736 14.4659C6.52151 16.0695 5.99471 17.8977 5.91367 19.7476V19.7476C5.88101 20.4933 6.68927 20.9922 7.33051 20.6102V20.6102C8.98354 19.6254 10.3566 18.2335 11.3187 16.5671L16.4564 7.66833M12.643 5.46669L16.4564 7.66833",
    stroke: "#363A44",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCcpEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ccp_edit.62cbb031237301c3ce2a9a94f45bf3b5.svg";